// // import { Button } from "../../Components/ui/button";
// import { Button } from "../../../Components/ui/button"
// import { useNavigate, useLocation } from "react-router-dom";
// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import { RootState } from "../../../State/store";

// // Mock Card components
// const Card = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
//   <div className={`bg-white border rounded-lg shadow-sm ${className}`}>{children}</div>
// );
// const CardContent = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
//   <div className={`${className}`}>{children}</div>
// );

// const StatusBox = ({ label, status }: { label: string; status: string }) => {
//   const isApproved = status === "approved";
//   const isPartial = status === "partial approved";
//   const isRejected = status === "rejected";
//   const hideStatusText = ["Start", "End", "Campaign Creation"].includes(label);
//   const navigate = useNavigate();

// const handleBackClick = () => {
//   navigate("/adminNavbar/templates");
// };

//   // Color mapping
//   const bgColor = isApproved
//     ? "bg-blue-600 text-white" // Approved
//     : isPartial
//       ? "bg-blue-400 text-white" // Partial Approved
//       : isRejected
//         ? "bg-red-600 text-white" // Rejected
//         : "bg-gray-200 text-gray-600"; // Pending

//   const statusTextColor = isApproved || isPartial
//     ? "text-gray-600"
//     : isRejected
//       ? "text-red-600"
//       : "text-gray-400";

//   return (
//     <div className="flex flex-col items-center min-w-[140px]">
//       {/* Back Button */}
//       <div className="fixed flex justify-end items-center right-0 top-[-15px] z-20 p-4">
//         <Button
//           onClick={handleBackClick}
//           className="w-30 text-sm text-[#F8FAFC] font-medium h-[35px] mt-[10px] cursor-pointer"
//         >
//           Back
//         </Button>
//       </div>

//       {/* Status Box */}
//       <div
//         className={`rounded-md px-6 py-6 text-sm font-semibold w-full text-center ${bgColor}`}
//       >
//         {label}
//       </div>

//       {/* Status Text */}
//       <div
//         className={`text-xs mt-2 ${statusTextColor} ${hideStatusText ? "invisible" : ""
//           }`}
//       >
//         {isApproved
//           ? "Approved"
//           : isPartial
//             ? "Partially Approved"
//             : isRejected
//               ? "Rejected"
//               : "Pending"}
//       </div>
//     </div>
//   );
// };

// // Helper function to format event time with appropriate prefix
// const formatEventTime = (eventTime: string, status: string): string => {
//   if (!eventTime) return "";

//   const prefix = status === "rejected" ? "Rejected at:" : "Approved at:";
//   const date = new Date(eventTime);

//   // Format to match your desired format
//   const formattedDate = date.toLocaleString("en-GB", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: false
//   }).replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$1/$2/$3");

//   return `${prefix} ${formattedDate}`;
// };

// export default function ApprovalTimeline() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { campaignId, channel_type } = location.state as {
//   campaignId: number;
//   channel_type: number;
// };
  
//   const campaign_id = campaignId;

//   const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
//   const [steps, setSteps] = useState<{ label: string; status: string }[]>([]);
//   const [verticalTimeline, setVerticalTimeline] = useState<any[]>([]);
//   const apiUrlAdminAcc = useSelector((state: RootState) => state.authentication.adminUrl);

//   useEffect(() => {
//     console.log("Received campaign_id:", campaign_id);
//     console.log("API URLs:", { apiUrlAdvAcc, apiUrlAdminAcc });
//     console.log("Channels from state:", channel_type);

//     if (campaign_id && apiUrlAdvAcc && apiUrlAdminAcc) {
// const GetHorizontalTimelineStatus = async () => {
//   try {
// const response = await axios.get(
//   `${apiUrlAdvAcc}/GetAdminTemplateHorizontalTimelineStatus`,
//   {
//     params: {
//       campaign_id: campaignId,          // be explicit
//       channel_type: Number(channel_type) // ensure it's number
//     },
//   }
// );


//     if (response.data.status === "Success") {
//       let apiSteps = response.data.data.map((item: any) => ({
//         label: item.stage,
//         status: item.status.toLowerCase(),
//       }));

//       // 🔹 Clean channels (remove null/undefined/empty)
//       // const cleanChannels = (channel_type || [])
//       //   .filter((ch: any) => ch && typeof ch === "string")
//       //   .map((ch: string) => ch.toLowerCase());

//       const cleanChannels =
//   channel_type === 1
//     ? ["whatsapp"]
//     : channel_type === 2
//     ? ["sms"]
//     : [];


//       console.log("Clean Channels:", cleanChannels);

//       // ✅ If only SMS → remove WABA Approval
//       if (cleanChannels.length === 1 && cleanChannels[0] === "sms") {
//         apiSteps = apiSteps.filter(
//           (step: any) => step.label.toLowerCase() !== "waba approval"
//         );

//         // ✅ If Operator Approval is approved → mark End as approved
//         const operatorApproved = apiSteps.some(
//           (step: any) =>
//             step.label.toLowerCase() === "operator approval" &&
//             step.status === "approved"
//         );

//         if (operatorApproved) {
//           apiSteps = apiSteps.map((step: any) =>
//             step.label.toLowerCase() === "end"
//               ? { ...step, status: "approved" }
//               : step
//           );
//         }
//       }

//       setSteps(apiSteps);
//     } else {
//       console.warn("No timeline status found");
//     }
//   } catch (error) {
//     console.error("Error fetching horizontal timeline status:", error);
//   }
// };




// const GetVerticalTimeline = async () => {
//   try {
//     const response = await axios.get(`${apiUrlAdminAcc}/GetTemplateAdminVerticalTimeline`, {
//       params: { template_id: campaignId },
//     });

//     if (response.data.status === "Success") {
//       const events = response.data.data;

//       // 🎯 Dynamic Next Stage Logic
//       const lastEvent = events[events.length - 1];
//       let nextStage = null;

//       if (lastEvent) {
//         const lastTitle = lastEvent.title;

//         // Case 1: Template Created → show Operator Approval
//         if (lastTitle === "Template Created") {
//           nextStage = { 
//             title: "Operator Approval", 
//             status: "pending",
//             comment: null,
//             event_time: null
//           };
//         }
//         // Case 2: Operator Rejected → show Template Resubmitted
//         else if (lastTitle === "Operator Rejected") {
//           nextStage = { 
//             title: "Template Resubmitted", 
//             status: "pending",
//             comment: null,
//             event_time: null
//           };
//         }
//         // Case 3: Template Resubmitted → show Operator Approval again
//         else if (lastTitle === "Template Resubmitted") {
//           nextStage = { 
//             title: "Operator Approval", 
//             status: "pending",
//             comment: null,
//             event_time: null
//           };
//         }
//         // Case 4: Operator Approved → show WABA Approval
//         else if (lastTitle === "Operator Approved") {
//           nextStage = { 
//             title: "WABA Approval", 
//             status: "pending",
//             comment: null,
//             event_time: null
//           };
//         }
//         // Case 5: WABA Rejected → show Template Resubmitted
//         else if (lastTitle === "WABA Rejected") {
//           nextStage = { 
//             title: "Template Resubmitted", 
//             status: "pending",
//             comment: null,
//             event_time: null
//           };
//         }
//         // If WABA Approved or any other final state, no next stage
//       }

//       // Merge real events with next stage
//       const finalTimeline = nextStage ? [...events, nextStage] : events;

//       setVerticalTimeline(finalTimeline);
//     } else {
//       console.warn("Vertical timeline fetch failed:", response.data.status_Description);
//     }
//   } catch (error) {
//     console.error("Error fetching vertical timeline:", error);
//   }
// };

//       GetHorizontalTimelineStatus();
//       GetVerticalTimeline();
//     } else {
//       console.warn("campaign_id or API URLs are undefined, API calls not triggered");
//     }
//   }, [campaign_id, apiUrlAdvAcc, apiUrlAdminAcc, channel_type]);


//   return (
//     <div className="p-8 bg-white min-h-screen">
//       {/* Horizontal Status Bar */}
//       <div className="flex items-center justify-center w-full max-w-6xl mx-auto mb-16">
//         {steps.map((step, index) => (
//           <React.Fragment key={index}>
//             <StatusBox label={step.label} status={step.status} />
//             {index < steps.length - 1 && (
//               <div
//                 className={`h-1 w-10 mt-4 mb-8 top-[-10px] ${step.status === "approved" && steps[index + 1].status === "approved"
//                     ? "bg-blue-600"
//                     : "bg-gray-300"
//                   }`}
//               ></div>
//             )}
//           </React.Fragment>
//         ))}
//       </div>

//       {/* Vertical Timeline */}
//       <div className="flex justify-center mb-16">
//         <div className="relative max-w-4xl w-full">
//           <div className="relative z-10">
//             {verticalTimeline.map((event: any, index: number) => {
//               const isLeftSide = index % 2 === 0;
//               const isPending = event.status?.toLowerCase() === "pending";
//               const isRejected = event.status?.toLowerCase() === "rejected";
//               const isApproved = event.status?.toLowerCase() === "approved";

//               // Color logic for dots and text
//               const dotColor = isPending
//                 ? "bg-gray-400"
//                 : isRejected
//                   ? "bg-red-600"
//                   : "bg-blue-600";

//               const textColor = isPending
//                 ? "text-gray-400"
//                 : isRejected
//                   ? "text-red-700"
//                   : "text-blue-700";

//               const timeColor = isPending
//                 ? "text-gray-300"
//                 : isRejected
//                   ? "text-red-500"
//                   : "text-gray-500";

//               // Format the time with appropriate prefix
//               const formattedTime = event.event_time
//                 ? formatEventTime(event.event_time, event.status)
//                 : "";

//               return (
//                 <div key={index} className="relative py-8 pb-12 flex items-start">
//                   {index < verticalTimeline.length - 1 && (
//                     <div className="absolute left-1/2 top-3 h-full w-0.5 bg-blue-600 transform -translate-x-1/2 z-0" />
//                   )}
//                   <div
//                     className={`absolute left-1/2 top-3 w-3 h-3 rounded-full ${dotColor} transform -translate-x-1/2 z-10`}
//                   />

//                   {/* Left Side */}
//                   <div className="w-1/2 flex justify-end pr-4">
//                     <div className="w-72 -mt-6">
//                       {isLeftSide ? (
//                         <div className="text-right">
//                           <div className={`text-sm font-semibold ${textColor}`}>{event.title}</div>
//                           {formattedTime && (
//                             <div className={`text-xs ${timeColor} mt-1`}>{formattedTime}</div>
//                           )}
//                         </div>
//                       ) : (
//                         <div className="flex justify-end">
//                           {event.comment && (
//                             <Card className={`${isPending
//                                 ? "border-gray-200 bg-gray-50"
//                                 : isRejected
//                                   ? "border-red-200 bg-red-50"
//                                   : "border-blue-200 bg-blue-50"
//                               } max-w-xs`}>
//                               <CardContent className="p-4">
//                                 <div className={`text-sm font-semibold ${textColor} mb-2`}>
//                                   {event.comment.title}
//                                 </div>
//                                 <div className={`text-sm break-words whitespace-pre-wrap ${isPending
//                                     ? "text-gray-400"
//                                     : isRejected
//                                       ? "text-red-600"
//                                       : "text-blue-600"
//                                   }`}>
//                                   {event.comment.content}
//                                 </div>
//                               </CardContent>
//                             </Card>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Right Side */}
//                   <div className="w-1/2 flex justify-start pl-4">
//                     <div className="w-72 -mt-6">
//                       {!isLeftSide ? (
//                         <div className="text-left">
//                           <div className={`text-sm font-semibold ${textColor}`}>{event.title}</div>
//                           {formattedTime && (
//                             <div className={`text-xs ${timeColor} mt-1`}>{formattedTime}</div>
//                           )}
//                         </div>
//                       ) : (
//                         <div className="flex justify-start">
//                           {event.comment && (
//                             <Card className={`${isPending
//                                 ? "border-gray-200 bg-gray-50"
//                                 : isRejected
//                                   ? "border-red-200 bg-red-50"
//                                   : "border-blue-200 bg-blue-50"
//                               } max-w-xs`}>
//                               <CardContent className="p-4">
//                                 <div className={`text-sm font-semibold ${textColor} mb-2`}>
//                                   {event.comment.title}
//                                 </div>
//                                 <div className={`text-sm break-words whitespace-pre-wrap ${isPending
//                                     ? "text-gray-400"
//                                     : isRejected
//                                       ? "text-red-600"
//                                       : "text-blue-600"
//                                   }`}>
//                                   {event.comment.content}
//                                 </div>
//                               </CardContent>
//                             </Card>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import { Button } from "../../Components/ui/button";
import { Button } from "../../../Components/ui/button"
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { RootState } from "../../../State/store";

// Mock Card components
const Card = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div className={`bg-white border rounded-lg shadow-sm ${className}`}>{children}</div>
);
const CardContent = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div className={`${className}`}>{children}</div>
);

const StatusBox = ({ label, status }: { label: string; status: string }) => {
  const isApproved = status === "approved";
  const isPartial = status === "partial approved";
  const isRejected = status === "rejected";
  const hideStatusText = ["Start", "End", "Campaign Creation"].includes(label);
  const navigate = useNavigate();

const handleBackClick = () => {
  navigate("/adminNavbar/templates");
};

  // Color mapping
  const bgColor = isApproved
    ? "bg-blue-600 text-white" // Approved
    : isPartial
      ? "bg-blue-400 text-white" // Partial Approved
      : isRejected
        ? "bg-red-600 text-white" // Rejected
        : "bg-gray-200 text-gray-600"; // Pending

  const statusTextColor = isApproved || isPartial
    ? "text-gray-600"
    : isRejected
      ? "text-red-600"
      : "text-gray-400";

  return (
    <div className="flex flex-col items-center min-w-[140px]">
      {/* Back Button */}
      <div className="fixed flex justify-end items-center right-0 top-[-15px] z-20 p-4">
        <Button
          onClick={handleBackClick}
          className="w-30 text-sm text-[#F8FAFC] font-medium h-[35px] mt-[10px] cursor-pointer"
        >
          Back
        </Button>
      </div>

      {/* Status Box */}
      <div
        className={`rounded-md px-6 py-6 text-sm font-semibold w-full text-center ${bgColor}`}
      >
        {label}
      </div>

      {/* Status Text */}
      <div
        className={`text-xs mt-2 ${statusTextColor} ${hideStatusText ? "invisible" : ""
          }`}
      >
        {isApproved
          ? "Approved"
          : isPartial
            ? "Partially Approved"
            : isRejected
              ? "Rejected"
              : "Pending"}
      </div>
    </div>
  );
};

// Helper function to format event time with appropriate prefix
const formatEventTime = (eventTime: string, status: string): string => {
  if (!eventTime) return "";

  const prefix = status === "rejected" ? "Rejected at:" : "Approved at:";
  const date = new Date(eventTime);

  // Format to match your desired format
  const formattedDate = date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  }).replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$1/$2/$3");

  return `${prefix} ${formattedDate}`;
};

export default function ApprovalTimeline() {
  const location = useLocation();
  const navigate = useNavigate();
  const { campaignId, channel_type } = location.state as {
  campaignId: number;
  channel_type: number;
};
  
  const campaign_id = campaignId;

  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const [steps, setSteps] = useState<{ label: string; status: string }[]>([]);
  const [verticalTimeline, setVerticalTimeline] = useState<any[]>([]);
  const apiUrlAdminAcc = useSelector((state: RootState) => state.authentication.adminUrl);

  useEffect(() => {
    console.log("Received campaign_id:", campaign_id);
    console.log("API URLs:", { apiUrlAdvAcc, apiUrlAdminAcc });
    console.log("Channels from state:", channel_type);

    if (campaign_id && apiUrlAdvAcc && apiUrlAdminAcc) {
const GetHorizontalTimelineStatus = async () => {
  try {
const response = await axios.get(
  `${apiUrlAdvAcc}/GetAdminTemplateHorizontalTimelineStatus`,
  {
    params: {
      campaign_id: campaignId,          // be explicit
      channel_type: Number(channel_type) // ensure it's number
    },
  }
);


    if (response.data.status === "Success") {
      let apiSteps = response.data.data.map((item: any) => ({
        label: item.stage,
        status: item.status.toLowerCase(),
      }));

      // 🔹 Clean channels (remove null/undefined/empty)
      // const cleanChannels = (channel_type || [])
      //   .filter((ch: any) => ch && typeof ch === "string")
      //   .map((ch: string) => ch.toLowerCase());

      const cleanChannels =
  channel_type === 1
    ? ["whatsapp"]
    : channel_type === 2
    ? ["sms"]
    : [];


      console.log("Clean Channels:", cleanChannels);

      // ✅ If only SMS → remove WABA Approval
      if (cleanChannels.length === 1 && cleanChannels[0] === "sms") {
        apiSteps = apiSteps.filter(
          (step: any) => step.label.toLowerCase() !== "waba approval"
        );

        // ✅ If Operator Approval is approved → mark End as approved
        const operatorApproved = apiSteps.some(
          (step: any) =>
            step.label.toLowerCase() === "operator approval" &&
            step.status === "approved"
        );

        if (operatorApproved) {
          apiSteps = apiSteps.map((step: any) =>
            step.label.toLowerCase() === "end"
              ? { ...step, status: "approved" }
              : step
          );
        }
      }

      setSteps(apiSteps);
    } else {
      console.warn("No timeline status found");
    }
  } catch (error) {
    console.error("Error fetching horizontal timeline status:", error);
  }
};




      const GetVerticalTimeline = async () => {
        try {
          const response = await axios.get(`${apiUrlAdminAcc}/GetTemplateAdminVerticalTimeline`, {
            params: { template_id: campaignId }
,
          });

          if (response.data.status === "Success") {
            const events = response.data.data;

            // 🎯 Dynamic Next Stage Logic - Only show the NEXT expected stage
            const lastEvent = events[events.length - 1];
            let nextStage = null;

            if (lastEvent) {
              const lastTitle = lastEvent.title;

              // Case 1: Template Created → next is Operator Approval
              if (lastTitle === "Template Created") {
                nextStage = { 
                  title: "Operator Approval", 
                  status: "pending",
                  comment: null,
                  event_time: null
                };
              }
              // Case 2: Operator Rejected → next is Template Resubmitted (NOT Operator Approval)
              else if (lastTitle === "Operator Rejected") {
                nextStage = { 
                  title: "Template Resubmitted", 
                  status: "pending",
                  comment: null,
                  event_time: null
                };
              }
              // Case 3: Template Resubmitted → next is Operator Approval (cycle back)
              else if (lastTitle === "Template Resubmitted") {
                nextStage = { 
                  title: "Operator Approval", 
                  status: "pending",
                  comment: null,
                  event_time: null
                };
              }
              // Case 4: Operator Approved → next is WABA Approval
              else if (lastTitle === "Operator Approved") {
                if (channel_type === 1) {
                nextStage = { 
                  title: "WABA Approval", 
                  status: "pending",
                  comment: null,
                  event_time: null
                };
              }
              // Case 5: WABA Rejected → NO next stage (WABA rejection is final)
              // Case 6: WABA Approved → NO next stage (completed successfully)
              // No else needed - nextStage stays null for final states
            }
          }

            // Merge real events with the dynamically calculated next stage
            const finalTimeline = nextStage ? [...events, nextStage] : events;

            setVerticalTimeline(finalTimeline);
          } else {
            console.warn("Vertical timeline fetch failed:", response.data.status_Description);
          }
        } catch (error) {
          console.error("Error fetching vertical timeline:", error);
        }
      };

      GetHorizontalTimelineStatus();
      GetVerticalTimeline();
    } else {
      console.warn("campaign_id or API URLs are undefined, API calls not triggered");
    }
  }, [campaign_id, apiUrlAdvAcc, apiUrlAdminAcc, channel_type]);


  return (
    <div className="p-8 bg-white min-h-screen">
      {/* Horizontal Status Bar */}
      <div className="flex items-center justify-center w-full max-w-6xl mx-auto mb-16">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <StatusBox label={step.label} status={step.status} />
            {index < steps.length - 1 && (
              <div
                className={`h-1 w-10 mt-4 mb-8 top-[-10px] ${step.status === "approved" && steps[index + 1].status === "approved"
                    ? "bg-blue-600"
                    : "bg-gray-300"
                  }`}
              ></div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Vertical Timeline */}
      <div className="flex justify-center mb-16">
        <div className="relative max-w-4xl w-full">
          <div className="relative z-10">
            {verticalTimeline.map((event: any, index: number) => {
              const isLeftSide = index % 2 === 0;
              const isPending = event.status?.toLowerCase() === "pending";
              const isRejected = event.status?.toLowerCase() === "rejected";
              const isApproved = event.status?.toLowerCase() === "approved";

              // Color logic for dots and text
              const dotColor = isPending
                ? "bg-gray-400"
                : isRejected
                  ? "bg-red-600"
                  : "bg-blue-600";

              const textColor = isPending
                ? "text-gray-400"
                : isRejected
                  ? "text-red-700"
                  : "text-blue-700";

              const timeColor = isPending
                ? "text-gray-300"
                : isRejected
                  ? "text-red-500"
                  : "text-gray-500";

              // Format the time with appropriate prefix
              const formattedTime = event.event_time
                ? formatEventTime(event.event_time, event.status)
                : "";

              return (
                <div key={index} className="relative py-8 pb-12 flex items-start">
                  {index < verticalTimeline.length - 1 && (
                    <div className="absolute left-1/2 top-3 h-full w-0.5 bg-blue-600 transform -translate-x-1/2 z-0" />
                  )}
                  <div
                    className={`absolute left-1/2 top-3 w-3 h-3 rounded-full ${dotColor} transform -translate-x-1/2 z-10`}
                  />

                  {/* Left Side */}
                  <div className="w-1/2 flex justify-end pr-4">
                    <div className="w-72 -mt-6">
                      {isLeftSide ? (
                        <div className="text-right">
                          <div className={`text-sm font-semibold ${textColor}`}>{event.title}</div>
                          {formattedTime && (
                            <div className={`text-xs ${timeColor} mt-1`}>{formattedTime}</div>
                          )}
                        </div>
                      ) : (
                        <div className="flex justify-end">
                          {event.comment && (
                            <Card className={`${isPending
                                ? "border-gray-200 bg-gray-50"
                                : isRejected
                                  ? "border-red-200 bg-red-50"
                                  : "border-blue-200 bg-blue-50"
                              } max-w-xs`}>
                              <CardContent className="p-4">
                                <div className={`text-sm font-semibold ${textColor} mb-2`}>
                                  {event.comment.title}
                                </div>
                                <div className={`text-sm break-words whitespace-pre-wrap ${isPending
                                    ? "text-gray-400"
                                    : isRejected
                                      ? "text-red-600"
                                      : "text-blue-600"
                                  }`}>
                                  {event.comment.content}
                                </div>
                              </CardContent>
                            </Card>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right Side */}
                  <div className="w-1/2 flex justify-start pl-4">
                    <div className="w-72 -mt-6">
                      {!isLeftSide ? (
                        <div className="text-left">
                          <div className={`text-sm font-semibold ${textColor}`}>{event.title}</div>
                          {formattedTime && (
                            <div className={`text-xs ${timeColor} mt-1`}>{formattedTime}</div>
                          )}
                        </div>
                      ) : (
                        <div className="flex justify-start">
                          {event.comment && (
                            <Card className={`${isPending
                                ? "border-gray-200 bg-gray-50"
                                : isRejected
                                  ? "border-red-200 bg-red-50"
                                  : "border-blue-200 bg-blue-50"
                              } max-w-xs`}>
                              <CardContent className="p-4">
                                <div className={`text-sm font-semibold ${textColor} mb-2`}>
                                  {event.comment.title}
                                </div>
                                <div className={`text-sm break-words whitespace-pre-wrap ${isPending
                                    ? "text-gray-400"
                                    : isRejected
                                      ? "text-red-600"
                                      : "text-blue-600"
                                  }`}>
                                  {event.comment.content}
                                </div>
                              </CardContent>
                            </Card>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}